import {
  LoadingOutlined,
} from '@ant-design/icons';
import {
  Button,
  Card, Col, DatePicker, Form, notification, Popconfirm, Row, Spin,
} from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import getUserRole from '../../../../utils/localeStorage/getUserRole';
import { NirReport } from './NirReport';
import { getCoexecutorStepById, updateCoexecutorStep } from '../../../../utils/http';
import { Act } from './Act';


const CoexecutorStep = ({ step, onDeleteStep, isLastStep }) => {
  const [stepData, setStepData] = useState(null);
  const [loading, setLoading] = useState(false);

  const form = useRef();

  const refetchData = async () => {
    try {
      const resp = await getCoexecutorStepById(step.id);
      setStepData(JSON.parse(resp.payload[0].stepJSON));
    } catch (e) {
      notification.error({ message: 'Произошла ошибка. Попробуйте еще раз' });
    }
  };

  const handleUpdateEndDate = async () => {
    setLoading(true);
    const values = await form.current.validateFields();

    const resp = await updateCoexecutorStep({ ...step, stepJSON: JSON.stringify({ ...stepData, endDate: values.endDate }) });

    if (resp.status === 'OK') {
      await refetchData();
      setLoading(false);
      notification.success({ message: 'Сохранено' });
      return;
    }

    setLoading(false);
    notification.error({ message: 'Произошла ошибка. Попробуйте еще раз' });
  };

  useEffect(() => {
    if (step && step.stepJSON) {
      setStepData(JSON.parse(step.stepJSON));
    } else {
      setStepData({});
    }
  }, [step]);

  if (!stepData) return <></>;

  return (
    <div className="application-reports">
      {loading && (
        <Spin
          style={{ position: 'fixed', fontSize: '60px', top: '30%' }}
          indicator={(<LoadingOutlined style={{ fontSize: '100px', margin: '-80px 0px 0px -60px' }} spin />)}
          tip="Загрузка..."
        >
          <div />
        </Spin>
      )}
      <Col>
        {getUserRole() === 'bigAdmin' && (
        <Card style={{ width: '100%', borderRadius: '15px', marginTop: '20px' }}>
          <div className="application-main-wrapper" style={{ display: 'flex', padding: 0 }}>
            <Col>
              <Form
                initialValues={{ remember: true }}
                ref={form}
              >
                <div className="application-main-box-content-wrapper" style={{ padding: 0}}>
                  <span className="application-main-box-label">Дата окончания этапа</span>
                  <Form.Item
                    name="endDate"
                    initialValue={stepData.endDate ? moment(stepData.endDate) : null}
                  >
                    <DatePicker style={{ width: '100%' }} format="DD.MM.YYYY" />
                  </Form.Item>
                </div>
              </Form>
              <Row style={{ marginTop: '20px' }} gutter={10}>
                <Col><Button type="primary" onClick={handleUpdateEndDate}>Сохранить</Button></Col>
                {isLastStep && (
                <Col>
                  <Popconfirm
                    title="Вы действительно удалить этап?"
                    onConfirm={onDeleteStep}
                    okText="Да"
                    cancelText="Нет"
                  >
                    <Button type="danger">Удалить этап</Button>
                  </Popconfirm>
                </Col>
                )}
              </Row>
            </Col>
          </div>
        </Card>
        )}

        <NirReport stepId={step.id} stepData={stepData} onRefetchData={refetchData} />

        <Act stepId={step.id} stepData={stepData} onRefetchData={refetchData} />

      </Col>


    </div>
  );
};

CoexecutorStep.propTypes = {
  step: PropTypes.shape().isRequired,
  onDeleteStep: PropTypes.func.isRequired,
  isLastStep: PropTypes.bool.isRequired,
};

export default CoexecutorStep;
